import type { Snapshot } from '@ember-data/legacy-compat/-private';
import ApplicationAdapter from 'lumen/adapters/application';

export default class BeniUpsellAdapter extends ApplicationAdapter {
  // @ts-expect-error: Property 'buildURL' in type 'BeniUpsellAdapter' is not assignable to the same property in base type 'ApplicationAdapter'.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  buildURL(
    modelName: string,
    id: string,
    snapshot: Snapshot,
    requestType: string,
    query: Record<string, unknown>,
  ) {
    // This is for calling `.save()` on the record.
    // By default, Ember Data will call `/beni-upsells/:id` for updating the record.
    // We want to call `/benchmarkinsight/upsell/?subscription_id=:id` instead, so we need to overwrite the URL here.
    if (requestType === 'updateRecord') {
      return `${this.host}/${this.namespace}/benchmarkinsight/upsell/?subscription_id=${id}`;
    }

    // @ts-expect-error: Expected 3 arguments, but got 5.
    return super.buildURL(modelName, id, snapshot, requestType, query);
  }

  pathForType(modelName: string): string {
    // This is for calling `queryRecord` with `typeKey: 'benchmarkinsight/upsell'`
    // By default, Ember Data will pluralise the key and call `/benchmarkinsight/upsells`.
    // We want to call `/benchmarkinsight/upsell` instead, so we need to overwrite the path here.
    return modelName;
  }
}
